import { render } from "./Window.layout.vue?vue&type=template&id=0089e383"
import script from "./Window.layout.vue?vue&type=script&lang=js"
export * from "./Window.layout.vue?vue&type=script&lang=js"

import "./Window.layout.vue?vue&type=style&index=0&id=0089e383&scope=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__